import type { EngagementPlatformPluginOptions } from '@atlaskit/editor-plugin-engagement-platform';

interface Props {
	options: EngagementPlatformPluginOptions;
}

export function engagementPlatformPluginOptions({
	options,
}: Props): EngagementPlatformPluginOptions {
	return options;
}
